import _classCallCheck from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/inherits";
import _objectSpread from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "/jenkins/workspace/jenkins-non-prod-pipelines-LOS-UI-Login-UI-qa-11/packages/react-scripts/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import Select from 'react-select';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import NoSsr from '@material-ui/core/NoSsr';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Popper from '@material-ui/core/Popper';
export var nullify = function nullify() {
  return null;
};

var styles = function styles(theme) {
  return {
    root: {
      flexGrow: 1,
      width: '100%'
    },
    input: {
      display: 'flex',
      padding: 0,
      backgroundColor: 'white',
      height: 22
    },
    error: {
      border: '1px solid red'
    },
    border: {
      border: '1px solid #ccc'
    },
    valueContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      flex: 1,
      alignItems: 'center'
    },
    noOptionsMessage: {
      padding: "".concat(theme.spacing(1), "px ").concat(theme.spacing(2), "px")
    },
    typography: {
      fontSize: 12,
      paddingLeft: 4
    },
    paper: {
      zIndex: 1,
      marginTop: theme.spacing(1),
      backgroundColor: 'white',
      border: '1px solid black',
      width: '500px'
    },
    menuItem: {
      height: 0,
      fontSize: 14
    },
    hide: {
      display: 'none'
    }
  };
};

function NoOptionsMessage(props) {
  return React.createElement(Typography, Object.assign({
    color: "textSecondary",
    className: props.selectProps.classes.noOptionsMessage
  }, props.innerProps), props.children);
}

function inputComponent(_ref) {
  var inputRef = _ref.inputRef,
      props = _objectWithoutProperties(_ref, ["inputRef"]);

  return React.createElement("div", Object.assign({
    ref: inputRef
  }, props));
}

function Control(props) {
  var _props$selectProps = props.selectProps,
      validate = _props$selectProps.validate,
      classes = _props$selectProps.classes,
      name = _props$selectProps.name,
      textFieldProps = _props$selectProps.textFieldProps;
  var border = validate ? classes.error : classes.border;
  return React.createElement(TextField, Object.assign({
    fullWidth: true,
    InputProps: {
      disableUnderline: true,
      inputComponent: inputComponent,
      inputProps: _objectSpread({
        'data-testid': 'smart-dropdown-input',
        name: name,
        className: "".concat(classes.input, " ").concat(border),
        children: props.children
      }, props.innerProps)
    }
  }, textFieldProps));
}

function Option(props) {
  return React.createElement(MenuItem, Object.assign({
    classes: {
      root: props.selectProps.classes.menuItem
    },
    buttonRef: props.innerRef,
    selected: props.isFocused,
    component: "div",
    style: {
      fontWeight: props.isSelected ? 500 : 400
    }
  }, props.innerProps), props.children);
}

function SingleValue(props) {
  return React.createElement(Typography, Object.assign({
    className: props.selectProps.classes.typography
  }, props.innerProps), props.children);
}

function ValueContainer(props) {
  return React.createElement("div", {
    className: props.selectProps.classes.valueContainer
  }, props.children);
}

function Menu(props) {
  return (// <FormControl fullWidth>
    React.createElement(Popper, Object.assign({
      open: true,
      anchorEl: props.selectProps.inputNode.current,
      className: props.selectProps.classes.paper
    }, props.innerProps, {
      modifiers: {
        preventOverflow: {
          enabled: false,
          boundariesElement: 'scrollParent'
        },
        hide: {
          enabled: false
        }
      }
    }), React.createElement("div", Object.assign({}, props.innerProps, {
      style: {
        minWidth: props.selectProps.inputNode.current.clientWidth
      },
      "data-testid": "smart-dropdown-menu"
    }), props.children)) // </FormControl>

  );
}

var components = {
  Control: Control,
  Menu: Menu,
  NoOptionsMessage: NoOptionsMessage,
  Option: Option,
  SingleValue: SingleValue,
  ValueContainer: ValueContainer
};

var SmartDropdown =
/*#__PURE__*/
function (_React$Component) {
  _inherits(SmartDropdown, _React$Component);

  function SmartDropdown() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, SmartDropdown);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SmartDropdown)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.inputNode = React.createRef();
    _this.state = {
      value: _this.props.value,
      label: ''
    };

    _this.changeValue = function (e) {
      _this.setState({
        value: e.value || '',
        label: e.label || ''
      }, function () {
        return _this.props.onChange(e.value);
      });
    };

    return _this;
  }

  _createClass(SmartDropdown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var valueMatch = this.props.options.find(function (option) {
        return option.value === _this2.props.value;
      });

      if (valueMatch !== undefined) {
        this.setState({
          label: valueMatch.text
        });
      }
    }
  }, {
    key: "determineIndex",
    value: function determineIndex(options, choice) {
      var index = -1;
      options.forEach(function (option, i) {
        if (option.value === choice) {
          index = i;
        }
      });
      return index;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          classes = _this$props.classes,
          theme = _this$props.theme;
      var value = this.state.value;
      var selectStyles = {
        input: function input(base) {
          return _objectSpread({}, base, {
            color: theme.palette.text.primary,
            '& input': {
              font: 'inherit'
            }
          });
        }
      };
      var newOptions = this.props.options.map(function (option) {
        return {
          value: option.value,
          label: option.text
        };
      });
      var hide = this.props.hide ? classes.hide : '';
      var index = this.determineIndex(newOptions, value);
      return React.createElement("div", {
        className: "".concat(classes.root, " ").concat(hide),
        ref: this.inputNode,
        "data-testid": "smart-dropdown",
        id: this.props.id
      }, React.createElement(NoSsr, null, React.createElement(Select, {
        classes: classes,
        styles: _objectSpread({}, selectStyles),
        options: newOptions,
        components: components,
        value: newOptions[index],
        onChange: this.changeValue,
        inputNode: this.inputNode,
        openMenuOnFocus: true,
        name: this.props.name,
        onBlur: function onBlur() {
          return _this3.props.onBlur(value);
        },
        validate: this.props.validate,
        placeholder: this.props.placeholder
      })));
    }
  }]);

  return SmartDropdown;
}(React.Component);

SmartDropdown.defaultProps = {
  id: 'smart-dropdown',
  options: [],
  name: '',
  onChange: nullify,
  onBlur: nullify,
  validate: false,
  hide: false,
  placeholder: '',
  value: ''
};
export default withStyles(styles, {
  withTheme: true
})(SmartDropdown);